import { render, staticRenderFns } from "./WhatCan.vue?vue&type=template&id=4867576d&scoped=true"
import script from "./WhatCan.vue?vue&type=script&lang=js"
export * from "./WhatCan.vue?vue&type=script&lang=js"
import style0 from "./WhatCan.vue?vue&type=style&index=0&id=4867576d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867576d",
  null
  
)

export default component.exports